import { render, staticRenderFns } from "./IntegrationContent.vue?vue&type=template&id=bd09f0e4&scoped=true&"
var script = {}
import style0 from "./IntegrationContent.vue?vue&type=style&index=0&id=bd09f0e4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd09f0e4",
  null
  
)

export default component.exports